import React from "react";
import {
  MobileAlertOverlay,
  MobileAlertCard,
  MobileAlertTitle,
  MobileAlertMessage,
  MobileAlertInstruction,
} from "../MobileAlert/styled";
import { CopyButton, CopyRow } from "../UnsupportedBrowser/styled";

interface ConnectionErrorProps {
  translations: {
    title: string;
    message: string;
    instruction: string;
    retry: string;
  };
}

/**
 * El motor no respondió (red caída, proxy que traga la petición, timeout).
 * Es distinto de "la entrevista no existe": aquí el enlace sirve y lo que
 * toca es reintentar, así que no se le dice al candidato que no hay nada.
 */
const ConnectionError: React.FC<ConnectionErrorProps> = ({ translations }) => (
  <MobileAlertOverlay>
    <MobileAlertCard>
      <MobileAlertTitle>{translations.title}</MobileAlertTitle>
      <MobileAlertMessage>{translations.message}</MobileAlertMessage>
      <MobileAlertInstruction>{translations.instruction}</MobileAlertInstruction>
      <CopyRow>
        <CopyButton onClick={() => window.location.reload()}>
          {translations.retry}
        </CopyButton>
      </CopyRow>
    </MobileAlertCard>
  </MobileAlertOverlay>
);

export default ConnectionError;
